<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Imbottigliatori',
      link: '/imbottigliatori'
    }, {
      label: form.uuid ? 'Modifica Imbottigliatore' : 'Aggiungi nuovo Imbottigliatore'
    }]"
  />
  <form autocomplete="off">
    <InputText
      v-model="form.name"
      :error-fields="errorFields"
      name="name"
      :submitted="submitted"
    >
      Nome
    </InputText>

    <InputTextarea
      v-model="form.notes"
      :error-fields="errorFields"
      name="notes"
      :submitted="submitted"
    >
      Note
    </InputTextarea>

    <InputInteger
      v-model="form.maxRedistributable"
      :error-fields="errorFields"
      name="maxRedistributable"
      :submitted="submitted"
    >
      Quantità massima ridistribuibile
      <br><span class="text-sm">(in tonnellate)</span>
    </InputInteger>

    <SubmitButtons
      :create-and-back="createAndBack"
      :create-and-stay="createAndStay"
      :mode="form.uuid ? 'update' : 'create'"
      :pending="pending"
      :update-and-back="updateAndBack"
      :update-and-stay="updateAndStay"
    />
  </form>
</template>

<script setup>
import { reactive } from "vue";

import InputInteger from "@/components/form/InputInteger.vue";
import InputText from "@/components/form/InputText.vue";
import InputTextarea from "@/components/form/InputTextarea.vue";
import SubmitButtons from "@/components/form/SubmitButtons.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useAxios from "@/composables/axios";
import useForm from "@/composables/form";
import Validation from "@/services/validation";

const props = defineProps({
  id: {
    required: false,
    type: String,
    default: null
  },
});

const axios = useAxios();

let form = reactive({
  name: "",
  notes: "",
  maxRedistributable: null,
});

if (props.id) {
  const resp = await axios.get("/bottler/" + props.id);
  form = reactive(resp.data);
}

const rules = {
  name: {
    type: 'string',
    max: 64,
    required: true
  },
  maxRedistributable: {
    type: "integer",
    required: true,
    min: 0,
    max: 999999
  }
};

const { submitted, pending, errorFields, createAndBack, createAndStay, updateAndBack, updateAndStay } = useForm(form, 'bottler', rules, {
  create: 'Imbottigliatore creato con successo',
  update: 'Imbottigliatore modificato con successo'
}, '/imbottigliatori', () => {
  form.name = ''
  form.notes = '';
  form.maxRedistributable = null
})

</script>
